export const constants = {
    DATE_FORMAT: 'DD-MM-YYYY',
    DATE_TIME_FORMAT: 'YYYY-MM-DD HH:mm:ss'
};
